module.exports = __webpack_public_path__ + "img/twitter.f57ef9d1.png";